import { render } from "./UserDataBase.vue?vue&type=template&id=4a275938&scoped=true"
import script from "./UserDataBase.vue?vue&type=script&lang=js"
export * from "./UserDataBase.vue?vue&type=script&lang=js"

import "./UserDataBase.vue?vue&type=style&index=0&id=4a275938&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a275938"]])

export default __exports__